import ProductList from "../components/Product/list";

const ProductsPage = () => {
  return (
    <div className="products-page">
      <ProductList />
    </div>
  );
};

export default ProductsPage;
